import React from "react";
import { HTMLContentProps } from "./HtmlContent.type";
import styles from "./HtmlContent.module.css";
import moment from "moment";

const HTMLContent: React.FC<HTMLContentProps> = ({
  titleData,
  content,
  className,
  summary,
  date,
  isPrivacyPolicy,
  isPurchase
}) => {
  
  return (
    <div 
    // className="html-content" 
    className="container"
    >
      <h1 className={`${isPurchase ? styles.headText1 : styles.headText}`}>
        {titleData}
      </h1>
      {isPrivacyPolicy && summary && date && (
        <div className={styles.lastUpdate}>
          <h6>
            {summary} <span>{moment(date).format("DD-MM-YYYY")}</span>
          </h6>
        </div>
      )}

      <div
        dangerouslySetInnerHTML={{ __html: content }}
        className={`${className}`}
      />

    </div>
  );
};

export default HTMLContent;
